"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends7 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _colors = require("../../config/colors");

var _config = require("../../config/config");

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
} // import AdvancedProperties from './AdvancedProperties';


var NumberProperties = function NumberProperties(_ref) {
  var question = _ref.question,
      setQuestion = _ref.setQuestion,
      errorMessages = _ref.errorMessages;

  var _useState = (0, _react.useState)(false),
      maxLengthClicked = _useState[0],
      setMaxLengthClicked = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      minLengthClicked = _useState2[0],
      setMinLengthClicked = _useState2[1];

  var _useState3 = (0, _react.useState)({
    max_length: false,
    min_length: false,
    size: false,
    character_spacing: false
  }),
      focusActive = _useState3[0],
      setFocusActive = _useState3[1];

  var handleChange = function handleChange(e) {
    var _extends2, _extends3, _extends4;

    switch (e.target.name) {
      case 'max_length':
        setMaxLengthClicked(true);
        break;

      case 'min_length':
        setMinLengthClicked(true);
        break;

      default:
        break;
    }
    /* eslint-disable-next-line */


    e.target.value ? setFocusActive((0, _extends7["default"])({}, focusActive, (_extends2 = {}, _extends2[e.target.name] = true, _extends2))) : setFocusActive((0, _extends7["default"])({}, focusActive, (_extends3 = {}, _extends3[e.target.name] = false, _extends3)));
    setQuestion((0, _extends7["default"])({}, question, {
      data: (0, _extends7["default"])({}, question.data, (_extends4 = {}, _extends4[e.target.name] = e.target.value, _extends4))
    }));
  };

  var handleFocus = function handleFocus(e) {
    var _extends5, _extends6;
    /* eslint-disable-next-line */


    e.target.value ? setFocusActive((0, _extends7["default"])({}, focusActive, (_extends5 = {}, _extends5[e.target.name] = true, _extends5))) : setFocusActive((0, _extends7["default"])({}, focusActive, (_extends6 = {}, _extends6[e.target.name] = false, _extends6)));
    e.target.placeholder = '';
  };

  var maxLengthValidation = function maxLengthValidation() {
    if (errorMessages && !question.data.max_length) {
      return true;
    }

    if (question.data.max_length) {
      return false;
    }

    if (!maxLengthClicked && !question.data.max_length) {
      return false;
    }

    return true;
  };

  var minLengthValidation = function minLengthValidation() {
    if (errorMessages && !question.data.min_length) {
      return true;
    }

    if (question.data.min_length) {
      return false;
    }

    if (!minLengthClicked && !question.data.min_length) {
      return false;
    }

    return true;
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        fontSize: 14,
        fontWeight: 300
      }
    }, "Maximum Characters"),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.InputGroup, {
      className: "mb-3"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.FormControl, {
      min: 0,
      id: "basic-url-max",
      "aria-describedby": "basic-addon3",
      name: "max_length",
      type: "number",
      isInvalid: maxLengthValidation(),
      required: true,
      onChange: handleChange,
      value: question.data.max_length ? question.data.max_length : '',
      placeholder: _config.DEFAULT_PLACE_HOLDER_TEXT,
      onFocus: handleFocus,
      onBlur: function onBlur(e) {
        e.target.placeholder = _config.DEFAULT_PLACE_HOLDER_TEXT;
      },
      style: {
        backgroundColor: _colors.SIDEBAR_INPUTS_BACKGROUND_COLOR,
        fontSize: 14,
        fontWeight: 300
      },
      className: focusActive.max_length ? 'focusInputActive' : 'focusInput'
    }),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Control.Feedback, {
      type: "invalid"
    }, "Please Provide Valid Maximum Characters")))),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        fontSize: 14,
        fontWeight: 300
      }
    }, "Minimum Characters"),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.InputGroup, {
      className: "mb-3"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.FormControl, {
      min: 0,
      id: "basic-url-min",
      "aria-describedby": "basic-addon3",
      name: "min_length",
      isInvalid: minLengthValidation(),
      required: true,
      type: "number",
      onChange: handleChange,
      value: question.data.min_length ? question.data.min_length : '',
      placeholder: _config.DEFAULT_PLACE_HOLDER_TEXT,
      onFocus: handleFocus,
      onBlur: function onBlur(e) {
        e.target.placeholder = _config.DEFAULT_PLACE_HOLDER_TEXT;
      },
      style: {
        backgroundColor: _colors.SIDEBAR_INPUTS_BACKGROUND_COLOR,
        fontSize: 14,
        fontWeight: 300
      },
      className: focusActive.min_length ? 'focusInputActive' : 'focusInput'
    }),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Control.Feedback, {
      type: "invalid"
    }, "Please Provide Valid Minimum Characters")))))
  );
};

NumberProperties.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  question: _propTypes["default"].objectOf(_propTypes["default"].any).isRequired,
  setQuestion: _propTypes["default"].func.isRequired,
  errorMessages: _propTypes["default"].func.isRequired
} : {};

var _default = exports["default"] = NumberProperties;